import { DataStorage } from '@studyportals/data-storage';
import * as MicroserviceInjector from '@studyportals/microservice-injector';
import * as BodyScrollLock from 'body-scroll-lock';
import General from './Templates/Core/JS/General.js';
import { countriesAll } from '@studyportals/static-domain-data/countries/countries';
import { countryGetIsoCode } from '@studyportals/static-domain-data/countries/country-get-iso-code';
export type Country = { name: string; iso_code: string | null };
export type CountriesById = { [countryId: string]: Country | undefined };

const mapCountriesById = (): CountriesById => {
	const result: CountriesById = {};

	for (const c of countriesAll) {
		result[c.id] = { name: c.name, iso_code: countryGetIsoCode(c.id)?.toUpperCase() ?? null };
	}

	return result;
};

export interface IBundle {
	DataStorage: typeof DataStorage;
	MicroserviceInjector: typeof MicroserviceInjector;
	BodyScrollLock: typeof BodyScrollLock;
	Countries: CountriesById;
	General: typeof General;
}

window.Loot = {
	DataStorage,
	MicroserviceInjector,
	BodyScrollLock,
	Countries: mapCountriesById(),
	General
};
